import { useCallback, useState } from "react";
import type { MeetingShopProduct } from "./meetingProductTypes";

export function useMeetingShopProducts({ productIds }: { productIds: string[] }) {
  const [products, setProducts] = useState<MeetingShopProduct[]>([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    if (productIds.length === 0 || loading || loaded) return;

    setLoading(true);
    try {
      const results = await Promise.all(
        productIds.map(async (productId) => {
          const response = await fetch(`/api/products/${productId}`);
          if (!response.ok) return null;

          const data = (await response.json()) as { product?: MeetingShopProduct };
          return data.product ?? null;
        }),
      );

      setProducts(
        results.filter((product): product is MeetingShopProduct => product != null),
      );
      setLoaded(true);
    } finally {
      setLoading(false);
    }
  }, [loaded, loading, productIds]);

  return {
    products,
    loading,
    load,
  };
}
